<template>
  <createSubsidy />
</template>

<script>
// 补贴活动详情
import createSubsidy from './createSubsidy.vue'
export default {
  components: {
    createSubsidy
  },
}

</script>
